<template>
  <vs-modal @close="$emit('close')">
    <h1 class="title">
      Are you sure?
    </h1>
    <div class="description">
      <p>Once you delete the file from your history, it will be permanently removed from the server and connot be undone.</p>
    </div>
    <div class="buttons">
      <div class="columns">
        <div class="column is-half">
          <button
            class="button is-fullwidth"
            @click="$emit('close')"
          >
            Cancel
          </button>
        </div>
        <div class="column is-half">
          <button
            class="button is-danger is-fullwidth"
            @click="deleteRecord()"
          >
            Yes, delete
          </button>
        </div>
      </div>
    </div>
  </vs-modal>
</template>

<script>
export default {
  methods: {
    deleteRecord () {
      this.$parent.$parent.deleteRecord()
      this.$parent.close()
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  color: $gray-800;
  font-size: 31px;
}

.buttons {
  margin-top: 30px;

  .columns {
    width: 100%;
  }
}
</style>
